// Deferred Sentry initialization to reduce initial bundle size
// Sentry Replay adds ~32KB to the bundle and is not critical for initial page load

let sentryInitialized = false;

export const initializeSentry = async () => {
  if (sentryInitialized || typeof window === 'undefined') return;
  
  try {
    const { init, replayIntegration, browserTracingIntegration } = await import('@sentry/react');
    
    init({
      dsn: "https://ce25fb9a99ae6b63bd4b4e94b5fd2fc2@o4508770556231680.ingest.de.sentry.io/4508770560360528",
      integrations: [
        browserTracingIntegration(),
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", /^https:\/\/fabbrichetoscane\.it/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    sentryInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};

// Initialize after page is interactive
if (typeof window !== 'undefined') {
  if (document.readyState === 'complete') {
    // Page already loaded
    setTimeout(initializeSentry, 1000);
  } else {
    // Wait for page to be interactive
    window.addEventListener('load', () => {
      setTimeout(initializeSentry, 1000);
    });
  }
}
